module.exports = __webpack_public_path__ + "static/media/dropbox-social-media-svgrepo-com (1).994d30e4.svg";